import React, { useEffect, useContext, useRef, useState } from 'react';
import { } from 'react-router'

import {
	 Grid
} from '@material-ui/core';

import {
	 PageHeader,
	 PageLoader,
	 ErrorView
} from '../../common';

import {
	 ConfigStatus,
	 TabContainer,
	 TabPanel,
	 StyleForm,
	 InfoForm,
	 MediaForm,
	MediaIconForm,
	 ServicesForm,
	 IosForm,
	 AndroidForm,
	 MenuForm,
	 WelcomeForm,
	 SettingsForm,
	 LiveViewDialog,
	 PublishConfigDialog
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { PluginContext, ToastContext } from '../../contexts';

import { FileType, ImageType, isDev } from '../../../helpers';
import { Aphorisms, LicenseStatus } from '../../../helpers';

import { RoutePaths, navigateTo } from '../../routing';

import { useTranslation } from "react-i18next";

import FlashOnIcon from '@material-ui/icons/FlashOn';
import PublishIcon from '@material-ui/icons/Publish';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
	 root: {
	 },
	 tabs: {
		  marginTop: theme.spacing(2)
	 }
}));

const PageContent = (props) => {
	 const classes = useStyles();

	 const { t } = useTranslation();

	 const {
		  state,
		  pageIsReady,
		  pageHasError,
		  setPageIsReady,
		  isBusy,
		  setIsBusy,
		  checkLicenseAsync,
		  getConfigurationAsync,
		  checkConfigChangesAsync,
		  saveConfigurationAsync,
		  resetConfigurationAsync,
		  updateLiveConfigAsync,
		  updateAppConfigAsync,
		  getLiveViewerQrCodeAsync,
		  createAppleCertsAsync,
		  createGoogleCertsAsync,
		  getWordPressCategoriesAsync,
		  getWordPressPagesAsync,
		  getIconClassesAsync,
		  validateAllAsync,
		  mergeSettings,
		  mergeMenuItems
	 } = useContext(PageContext);

	 const {
		  plugin
	 } = useContext(PluginContext);

	 const {
		  showSuccessMessage,
		  showErrorMessage
	 } = useContext(ToastContext);

	 const {
		  license,
		  settings,
		  menuItems,
		  isLegacy,
		  icons,
		  categories,
		  pages,
		  qrLiveViewer,
		  configStatus,
		  errors,
	 } = state;

	 const [aphorism, setAphorism] = useState(Aphorisms[Math.floor(Math.random() * Aphorisms.length)]);

	 const [openLVDialog, setOpenLVDialog] = useState(false);
	 const [openPubDialog, setOpenPubDialog] = useState(false);

	 const uploadAnyFileAsync = async (fileType, data, file, credentials) => {
		  setIsBusy({ uploading: true });
		  let storedFile = null;
		  switch (fileType) {
				case ImageType.AppIcon:
				case ImageType.AppSplash:
				case ImageType.MenuHeader:
				case ImageType.PhotoEditor:
				case ImageType.LoginPage:
				case ImageType.MenuItem:

					 // GIANKY
					 storedFile = { publicUrl: null };
					 let base64String1 = await readFileAsDataURL2(file);
					 storedFile.publicUrl = base64String1;
					 break;
				case FileType.iOSP12Certificate:
				case FileType.iOSP8Certificate:
				case FileType.iOSMobileProvisioning:
				case FileType.AndroidKeyStore:

					 // GIANKY

					 // credentials � solo per mandarle su Azure per controllo, si pu� fare in compilazione
					 // storedFile = await uploadFileAsync({ fileType, data, credentials });

					 storedFile = { publicUrl: null };
					 let base64String = await readFileAsDataURL(file);
					 storedFile.publicUrl = base64String; // In realt� non � un URL ma binario in Base64, devo tenerne conto in C#

					 break;
				default:
					 break;
		  }
		  setIsBusy({ uploading: false });
		  return storedFile;
	 }

	async function readFileAsDataURL(file)
	{
		let result_base64 = await new Promise((resolve) => {
			let fileReader = new FileReader();
			fileReader.onload = (e) => {
				const base64String = fileReader.result.split(',')[1]; // Remove the data URL prefix
				resolve(base64String);
			}
			fileReader.readAsDataURL(file);
		});
		return result_base64;
	}

	async function readFileAsDataURL2(file) {
		let result_base64 = await new Promise((resolve) => {
			let fileReader = new FileReader();
			fileReader.onload = (e) => {
				const base64String = fileReader.result;
				resolve(base64String);
			}
			fileReader.readAsDataURL(file);
		});
		return result_base64;
	}

	 const resetSettingsAsync = async () => {
		  setIsBusy({ reset: true });
		  await resetConfigurationAsync();
		  setIsBusy({ reset: false });
	 }

	 const requestAppleCertsAsync = async (keyId, teamId, email, bundleId) => {
		  setIsBusy({ creatingCerts: true });
		  const certsInfo = await createAppleCertsAsync({ keyId, teamId, email, bundleId });
		  setIsBusy({ creatingCerts: false });
		  return certsInfo;
	 }

	 const requestGoogleCertsAsync = async (keystoreAlias, email, bundleId) => {
		  setIsBusy({ creatingCerts: true });
		  const certsInfo = await createGoogleCertsAsync({ keystoreAlias, email, bundleId });
		  setIsBusy({ creatingCerts: false });
		  return certsInfo;
	 }

	 const formRef = useRef();
	 const saveAppConfigClickHandler = async (e) => {
		  if (formRef.current) {
				formRef.current.handleSubmit();
		  } else {
				setIsBusy({ saving: true });
				const success = await validateAllAsync(settings, menuItems);
				if (success) {
					 await saveConfigurationAsync(settings, menuItems);
					 await checkConfigChangesAsync();
					 showSuccessMessage(t("SuccessChangesSaved"));
				} else {
					 showErrorMessage(t("ErrorValuesNotValid"));
				}

				setIsBusy({ saving: false });
		  }
	 }

	 const tutorialClickHandler = async (e) => {
		  //window.open(`https://www.myfastapp.com/tutorial?vplugin=${plugin.pluginVersion}`, "_blank");
		  window.open("https://myfastapp.com/app-building-getting-started-with-my-fastapp/", "_blank");
	 }

	 const liveViewerClickHandler = async (e) => {
		  setIsBusy({ updatingLiveConfig: true });
		  const success = await updateLiveConfigAsync();
		  await checkConfigChangesAsync();
		  if (success) {
				await getLiveViewerQrCodeAsync();
				setOpenLVDialog(true);
				showSuccessMessage(t("SuccessLiveConfigUpdate"));
		  } else {
				showErrorMessage(t("ErrorLiveConfigUpdate"));
		  }
		  setIsBusy({ updatingLiveConfig: false });
	 }

	 const publishClickHandler = (e) => {
		  setOpenPubDialog(true);
	 }

	 const confirmPublishClickHandler = async () => {
		  setIsBusy({ updatingAppConfig: true });
		  setOpenPubDialog(false);
		  const success = await updateAppConfigAsync();
		  await checkConfigChangesAsync();
		  if (success) {
				showSuccessMessage(t("SuccessAppConfigUpdate"));
		  } else {
				showErrorMessage(t("ErrorAppConfigUpdate"));
		  }
		  setIsBusy({ updatingAppConfig: false });
	 }

	 const settingsBlurHandler = (values) => {
		  const newSettings = mergeSettings(values);
	 }

	 const settingsFormSubmitHandler = async (values, done) => {
		  setIsBusy({ saving: true });
		  const newSettings = mergeSettings(values);
		  const success = await validateAllAsync(newSettings, menuItems);
		  if (success) {
				await saveConfigurationAsync(newSettings, menuItems);
				await checkConfigChangesAsync();
				showSuccessMessage(t("SuccessChangesSaved"));
		  } else {
				showErrorMessage(t("ErrorValuesNotValid"));
		  }

		  done();
		  setIsBusy({ saving: false });
	 }

	 const menuItemFormSubmitHandler = async (values, done) => {
		  setIsBusy({ submit: true });
		  const newMenuItems = mergeMenuItems(values);
		  const success = await validateAllAsync(settings, newMenuItems);
		  if (success) {
				await saveConfigurationAsync(settings, newMenuItems);
				await checkConfigChangesAsync();
				showSuccessMessage(t("SuccessChangesSaved"));
		  } else {
				showErrorMessage(t("ErrorValuesNotValid"));
		  }

		  done();
		  setIsBusy({ submit: false });
	 }

	 const pageReadyDeps = [license, configStatus, settings, menuItems, categories, pages, icons];
	 useEffect(() => {
		  setPageIsReady([
				() => checkLicenseAsync(),
				() => checkConfigChangesAsync(),
				() => getConfigurationAsync(),
				() => getWordPressCategoriesAsync(),
				() => getWordPressPagesAsync(),
				() => getIconClassesAsync()
		  ], pageReadyDeps);
	 }, pageReadyDeps);

	 useEffect(() => {
		  if (isLegacy) {
				navigateTo(RoutePaths.Migrate);
		  }
	 }, [isLegacy]);

	 return (
		  <>
				{pageIsReady ?
					 pageHasError ?
						  <ErrorView />
						  :
						  <Grid container spacing={3} className={classes.root}>
								<Grid item xs={12}>
									 <PageHeader
										  save
										  add
										  action1
										  action2
										  title={t("LabelMain")}
										  subtitle={t("LabelConfigureApplication")}
										  saveButtonText={t("ButtonSaveChanges")}
										  addButtonText={t("ButtonTutorial")}
										  onAddClick={tutorialClickHandler}
										  action1StartIcon={<PublishIcon />}
										  action2StartIcon={<FlashOnIcon />}
										  action1ButtonText={t("ButtonPublish")}
										  action2ButtonText={t("ButtonLiveView")}
										  action1Disabled={license.status !== LicenseStatus.Active}
										  disabled={isBusy()}
										  onSaveClick={saveAppConfigClickHandler}
										  onAction1Click={publishClickHandler}
										  onAction2Click={liveViewerClickHandler}
									 />
								</Grid>

								<Grid item xs={12}>
									<ConfigStatus />
									{/* 
										Formik validate property is used to save the changes for each field.
										Validation is enabled only on blur (performance reason), 
										the values are updated on the PageContext.
									*/}
									<TabContainer className={classes.tabs}>

										<TabPanel label={t("LabelWelcome")} name="welcome" index={0}>
											<WelcomeForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												reset={resetSettingsAsync}
												onSubmit={settingsFormSubmitHandler}
											/>
										</TabPanel>

										<TabPanel label={t("LabelInfo")} name="info" index={1}>
											<MediaForm
												formRef={formRef}
												errors={errors}
												upload={uploadAnyFileAsync}
												disabled={isBusy()}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
											<br/>
											<StyleForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
										</TabPanel>

										<TabPanel label={t("LabelMenu")} name="menu" index={2}>
											<MenuForm
												formRef={formRef}
												errors={errors}
												upload={uploadAnyFileAsync}
												disabled={isBusy()}
												onSubmit={menuItemFormSubmitHandler}
											/>
										</TabPanel>

										<TabPanel label={t("LabelIos")} name="ios" index={3}>
											<InfoForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
											<br/>
											<MediaIconForm
												formRef={formRef}
												errors={errors}
												upload={uploadAnyFileAsync}
												disabled={isBusy()}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
											<br/>
											<AndroidForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												upload={uploadAnyFileAsync}
												createCerts={requestGoogleCertsAsync}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
											<br/>
											<IosForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												upload={uploadAnyFileAsync}
												createCerts={requestAppleCertsAsync}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
										</TabPanel>

										<TabPanel label={t("LabelServices")} name="services" index={4}>
											<ServicesForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												onBlur={settingsBlurHandler}
												onSubmit={settingsFormSubmitHandler}
											/>
										</TabPanel>

										<TabPanel label={t("LabelSettings")} name="settings" index={5}>
											<SettingsForm
												formRef={formRef}
												errors={errors}
												disabled={isBusy()}
												reset={resetSettingsAsync}
												onSubmit={settingsFormSubmitHandler}
											/>
										</TabPanel>

									</TabContainer>
								</Grid>
							</Grid>
					 :
					 <PageLoader aphorism={aphorism} enableAphorism />
				}

				<LiveViewDialog
					 open={openLVDialog}
					 onClose={(e) => setOpenLVDialog(false)}
				/>

				<PublishConfigDialog
					 open={openPubDialog}
					 onConfirm={(e) => confirmPublishClickHandler()}
					 onClose={(e) => setOpenPubDialog(false)}
				/>
		  </>
	 );
}

export const SettingsPage = () => {

	 return (
		  <PageProvider>
				<PageContent />
		  </PageProvider>
	 );
}